import { render, staticRenderFns } from "./MenuSecundario.vue?vue&type=template&id=c6f60eda&"
import script from "./MenuSecundario.vue?vue&type=script&lang=js&"
export * from "./MenuSecundario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports